import { campaignAnalyticsTypes } from '../../constants/types';
import Vue from 'vue';

const { setLiveCustomerCount, setLiveItemCount, loadDefaultCampaignAnalytics } = campaignAnalyticsTypes.actions;

export const mutations = {
  [setLiveCustomerCount]: (state, { response }) => {
    Vue.set(state, 'liveCustomerCount', response.data.value);
  },
  [setLiveItemCount]: (state, { response }) => {
    Vue.set(state, 'liveItemCount', response.data.value);
  },
  [loadDefaultCampaignAnalytics]: (state, { response }) => {
    const channelType = response.data.value.channel_type;

    if (channelType === 'dodo-mail') Vue.set(state, 'defaultDodoMailCampaignAnalytics', response.data.value.analytics);
    else if (channelType === 'website')
      Vue.set(state, 'defaultWebsiteCampaignAnalytics', response.data.value.analytics);
  }
};
